import React, { useEffect, useState } from 'react';
import { listInquiries } from '../../api/inquiriesApi';
import { formatWhen, statusOf } from '../../utils/inquiryView';
import '../../styles/inquiry.css';

/**
 * 自分のお問い合わせの一覧（新しい順）。番号・カテゴリ・状態（受付済み / 返信あり / 返信済み）・冒頭・日時。
 * タップで、そのやり取りへ（onOpen(id)）。一覧が読めなくても、画面のほかの部分（入力）は使える。
 * reloadKey が変わると、取り直す（送った直後に、一覧へ反映するため）。
 */
export default function InquiryList({ onOpen, reloadKey = 0 }) {
  const [state, setState] = useState({ rows: null, error: false });

  useEffect(() => {
    let cancelled = false;
    listInquiries()
      .then((res) => !cancelled && setState({ rows: res.inquiries || [], error: false }))
      .catch(() => !cancelled && setState({ rows: null, error: true }));
    return () => {
      cancelled = true;
    };
  }, [reloadKey]);

  if (state.error) return <div className="inq-empty">お問い合わせの一覧を読み込めませんでした</div>;
  if (state.rows === null) return <div className="inq-empty">読み込み中…</div>;
  if (state.rows.length === 0) return <div className="inq-empty">まだお問い合わせはありません</div>;

  return (
    <ul className="inq-list">
      {state.rows.map((r) => {
        const st = statusOf(r);
        return (
          <li key={r.id}>
            <button type="button" className="inq-row" onClick={() => onOpen?.(r.id)}>
              <div className="inq-row-top">
                <span className="inq-no">{r.numberLabel}</span>
                <span className="inq-cat">{r.category}</span>
                <span className={`inq-status inq-status--${st.key}`}>{st.label}</span>
              </div>
              <div className="inq-preview">{r.preview}</div>
              <div className="inq-when">{formatWhen(r.lastMessageAt)}</div>
            </button>
          </li>
        );
      })}
    </ul>
  );
}
